import { apiFetch } from './apiClient';

/* A tabela vem do backend (cópia do IBGE embutida lá) e é guardada em
   memória na primeira chamada: são 5.571 municípios, não faz sentido
   rebaixar isso a cada vez que a tela de emissão abre. A promessa fica
   em cache também, pra duas telas abrindo juntas não dispararem duas
   requisições. */
let cache = null;
let carregando = null;

export function listarMunicipios() {
  if (cache) return Promise.resolve(cache);
  if (!carregando) {
    carregando = apiFetch('/municipios')
      .then(r => { cache = r.items || []; return cache; })
      .catch(e => { carregando = null; throw e; });
  }
  return carregando;
}

function semAcento(t) {
  return String(t || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
}

/* busca local -- aceita nome (com ou sem acento) e código IBGE */
export function filtrarMunicipios(lista, termo, limite = 30) {
  const q = semAcento(termo);
  if (!q) return lista.slice(0, limite);
  const digitos = String(termo).replace(/\D/g, '');
  return lista
    .filter(m => semAcento(m.nome).includes(q) || (digitos && m.codigo.startsWith(digitos)))
    .slice(0, limite);
}

export function municipioPorCodigo(lista, codigo) {
  const c = String(codigo || '').replace(/\D/g, '');
  return lista.find(m => m.codigo === c) || null;
}
